import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=8247ea80&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"
import style0 from "./Languages.vue?vue&type=style&index=0&id=8247ea80&prod&scoped=true&lang=css"
import style1 from "./Languages.vue?vue&type=style&index=1&id=8247ea80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8247ea80",
  null
  
)

export default component.exports